<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start-->
<div class="afterLoginPageContainer">
    <div class="container">
        <div class="selectAreaOfInterest">
            <h3 class="my-3 title mb-1"> Area of Interest</h3>
            <p class="smLine">Select the Area of your interest</p>
            <div class="selectcategory my-4">
                <div *ngFor="let category of areaOfInterest" class="category-block">
                    <div class="custom-control custom-checkbox">
                        <input [id]="'cat-' + category.id" [name]="category.app_name_english" [value]="category.id"
                            class="custom-control-input" type="checkbox"
                            [checked]="isSelectedAreaOfInterest(category.id)"
                            (change)="onAreaOfInterestCheckboxChange($event, category.id)">
                        <label *ngIf="category.allow_to_add_by_user" [for]="'cat-' + category.id"
                            class="custom-control-label">
                            <div class="imgOut">
                                <img src="{{category.image_url}}" [alt]="category.app_name_english" class="img-fluid">
                            </div>
                            <p class="mb-0">{{ category.app_name_english }}</p>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="prefilledUserAreaOfInterestIds.length === 0 && selectedAreaOfInterestIds.length === 0"
                class="text-center err_msg mb-2">Please select at least one category.</div>
            <div class="space"></div>
            <div class="text-center my-3 footBtn">
                <button class="btn subBtn" type="submit" (click)="onContinue()"
                    [disabled]="prefilledUserAreaOfInterestIds.length === 0 && selectedAreaOfInterestIds.length === 0">Continue</button>
            </div>
        </div>
    </div>
</div>